import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FrameworkDataTable } from 'framework-data-table';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import { LOADING_PERCENTAGE_60, NUM_GOAL_TARGETS_PER_PAGE_OPTIONS, SORT_DIRECTION } from '../../constants/goals';
import { useFetchGoalTargets } from '../../hooks/setupGoalTargets';
import { TableLoadingBarContainer } from '../../utils/styles';
import EmptyTableState from './EmptyTableState';
import { getColumnsForGoalType } from '../../utils/goal';
export default function GoalsTable({
  goalType,
  status,
  milestone,
  percentProgressRange,
  endDateRange,
  adAccounts
}) {
  const [pageIndex, setPageIndex] = useState(0);
  const [selectedSortColumn, setSelectedSortColumn] = useState();
  const [selectedSortDirection, setSelectedSortDirection] = useState(SORT_DIRECTION.ASC);
  const [sorts, setSorts] = useState([]);
  const [numGoalTargetsPerPage, setNumGoalTargetsPerPage] = useState(NUM_GOAL_TARGETS_PER_PAGE_OPTIONS[0]);
  const {
    goalTargets,
    total,
    setOffset,
    tableLoadingPercentage
  } = useFetchGoalTargets({
    goalType,
    status,
    milestone,
    percentProgressRange,
    endDateRange,
    adAccounts
  }, selectedSortDirection, numGoalTargetsPerPage, selectedSortColumn);

  const getRowId = row => row.objectId;

  const columns = getColumnsForGoalType(goalType);
  const areGoalTargetsLoading = tableLoadingPercentage !== undefined && tableLoadingPercentage < LOADING_PERCENTAGE_60;
  const tableIsEmpty = !areGoalTargetsLoading && !goalTargets.length;
  const handleSortsChanged = useCallback(({
    nextSorts
  }) => {
    if (!nextSorts.length) return;
    const newColumnName = nextSorts[0].columnName;
    const newDirection = nextSorts[0].direction === -1 ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC;
    setSorts(nextSorts);
    setSelectedSortColumn(newColumnName);

    if (selectedSortColumn && newColumnName !== selectedSortColumn) {
      setSelectedSortDirection(SORT_DIRECTION.ASC);
      return;
    }

    setSelectedSortDirection(newDirection);
  }, [selectedSortColumn]);
  const handlePageSizeChange = useCallback(({
    nextPageSize
  }) => {
    setOffset(0);
    setPageIndex(0);
    setNumGoalTargetsPerPage(nextPageSize);
  }, [setOffset]);
  const handlePageIndexChange = useCallback(({
    nextPageIndex
  }) => {
    setOffset(nextPageIndex * numGoalTargetsPerPage);
    setPageIndex(nextPageIndex);
  }, [numGoalTargetsPerPage, setOffset]);
  if (tableIsEmpty) return /*#__PURE__*/_jsx(EmptyTableState, {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableLoadingBarContainer, {
      children: /*#__PURE__*/_jsx(UIAbstractProgress, {
        incrementFactor: 0.01,
        autoStart: true,
        value: tableLoadingPercentage,
        render: ({
          value
        }) => /*#__PURE__*/_jsx(UINanoProgress, {
          value: value,
          animateOnComplete: true
        })
      })
    }), /*#__PURE__*/_jsx(FrameworkDataTable, {
      columns: columns,
      getRowId: getRowId,
      hasGate: () => false,
      hasScope: () => false,
      loading: areGoalTargetsLoading,
      pageIndex: pageIndex,
      pageSize: numGoalTargetsPerPage,
      pageSizes: NUM_GOAL_TARGETS_PER_PAGE_OPTIONS,
      pageable: goalTargets && goalTargets.length > 0,
      reorderable: false,
      rows: goalTargets || [],
      selectable: false,
      sortable: true,
      sorts: sorts,
      totalRowCount: total,
      onSortsChange: handleSortsChanged,
      onPageSizeChange: handlePageSizeChange,
      onPageIndexChange: handlePageIndexChange
    })]
  });
}
GoalsTable.propTypes = {
  goalType: PropTypes.string.isRequired,
  status: PropTypes.arrayOf(PropTypes.string),
  milestone: PropTypes.arrayOf(PropTypes.string),
  percentProgressRange: PropTypes.object,
  endDateRange: PropTypes.object,
  adAccounts: PropTypes.arrayOf(PropTypes.string)
};